import React, { FC } from "react";
import { Box, Button, Heading, Icon, IconName } from "@telia/teddy";
import cn from "classnames";
import * as properNameCase from "../../../../../../shared/properNameCase";
import "./ContactCard.less";
import { PhoneNumberFormatters } from "../../../../app/utils";

interface ContactCardProps {
    address: string;
    addressContent?: React.ReactNode;
    city?: string;
    contactEmail?: string;
    contactName?: string;
    contactPhone?: string;
    name: string;
    showTriggerButton?: boolean;
    triggerFunction?: () => void;
    triggerIcon?: IconName;
    triggerInHeader?: boolean;
    triggerInsideAddress?: boolean;
    triggerText?: string;
    triggerVariant?: "link" | "pill";
}

const ContactCard: FC<ContactCardProps> = ({
    name,
    address,
    addressContent,
    city = "",
    contactName,
    contactPhone,
    contactEmail,
    showTriggerButton,
    triggerText = "Ny Kredittsjekk",
    triggerFunction,
    triggerIcon,
    triggerInHeader = false,
    triggerVariant = "link",
    triggerInsideAddress = false,
}) => {
    const showContactInfo = contactName || contactEmail || contactPhone;
    const formatter = contactPhone?.startsWith("+")
        ? PhoneNumberFormatters[4].displayFn
        : PhoneNumberFormatters[0].displayFn;

    return (
        <Box className="reseller-contact-card__section">
            <div
                className={cn("reseller-contact-card__content", {
                    "reseller-contact-card__content-shadow": true,
                })}
            >
                <div className="reseller-contact-card__wrapper" data-di-mask>
                    <div className="reseller-contact-card__address">
                        <div className="reseller-contact-card__heading-container">
                            <Heading as="h3" variant="title-100">
                                {properNameCase.convert(name)}
                            </Heading>
                            {showTriggerButton && triggerInHeader && (
                                <Button
                                    className={`reseller-contact-card__trigger-btn reseller-contact-card__trigger-btn--${triggerVariant}`}
                                    onClick={triggerFunction}
                                    variant={triggerVariant === "pill" ? "tertiary-purple" : "text"}
                                >
                                    <span className="reseller-contact-card__trigger-text">{triggerText}</span>
                                    {triggerIcon && (
                                        <Icon
                                            className="reseller-contact-card__trigger-icon"
                                            name={triggerIcon}
                                            aria-hidden="true"
                                            focusable="false"
                                        />
                                    )}
                                </Button>
                            )}
                        </div>
                        {properNameCase.convert(address)}
                        <br />
                        {properNameCase.convert(city)}
                        {showTriggerButton && triggerInsideAddress && (
                            <div className="reseller-contact-card__address-trigger">
                                <Button
                                    className={`reseller-contact-card__trigger-btn reseller-contact-card__trigger-btn--${triggerVariant}`}
                                    onClick={triggerFunction}
                                    variant={triggerVariant === "pill" ? "tertiary-purple" : "text"}
                                >
                                    <span className="reseller-contact-card__trigger-text">{triggerText}</span>
                                    {triggerIcon && (
                                        <Icon
                                            className="reseller-contact-card__trigger-icon"
                                            name={triggerIcon}
                                            aria-hidden="true"
                                            focusable="false"
                                        />
                                    )}
                                </Button>
                            </div>
                        )}
                        {addressContent}
                    </div>
                    {showContactInfo && (
                        <div className="contact-card-container__contact">
                            <Heading as="h3" variant="title-100">
                                Kontaktinformasjon:
                            </Heading>
                            {!!contactName && (
                                <>
                                    {contactName}
                                    <br />
                                </>
                            )}
                            {!!contactPhone && (
                                <>
                                    {formatter(contactPhone)}
                                    <br />
                                </>
                            )}
                            {contactEmail}
                        </div>
                    )}
                </div>
                {showTriggerButton && !triggerInHeader && !triggerInsideAddress && (
                    <div className="reseller-contact-card__creditCheck">
                        <Button
                            className="reseller-contact-card__creditCheck-btn"
                            variant="text"
                            onClick={triggerFunction}
                        >
                            {triggerText}
                            <Icon
                                className="reseller-contact-card__creditCheck-icon"
                                name="logout"
                                aria-hidden="true"
                                focusable="false"
                            />
                        </Button>
                    </div>
                )}
            </div>
        </Box>
    );
};

export default ContactCard;
